module.exports = __webpack_public_path__ + "img/usp.872858f4.svg";